/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO } from './FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Login: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Store: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Inapp?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp | null;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    PushTokens: FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Hub: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    if (!('Login' in value) || value['Login'] === undefined) return false;
    if (!('Store' in value) || value['Store'] === undefined) return false;
    if (!('PushTokens' in value) || value['PushTokens'] === undefined) return false;
    if (!('Hub' in value) || value['Hub'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    if (json == null) {
        return json;
    }
    return {
        
        'Login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON(json['login']),
        'Store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON(json['store']),
        'Inapp': json['inapp'] == null ? undefined : FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON(json['inapp']),
        'PushTokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON(json['PushTokens']),
        'Hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON(json['hub']),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON(value['Login']),
        'store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON(value['Store']),
        'inapp': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON(value['Inapp']),
        'PushTokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON(value['PushTokens']),
        'hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON(value['Hub']),
    };
}

